import React from 'react';
import { Outlet } from 'react-router-dom';
import Menu from './Menu';

const Main = () => {
  return (
    <div className='app-main-container'>
      <div className='border-bottom border-4 bg-light'>
        <nav>
          <Menu />
        </nav>
      </div>
      <div className='app-content'>
        <Outlet />
      </div>
    </div>
  );
};

export default Main;